import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import { STORAGE } from "../../constants";
import { AuthService } from "../../services/authService";
import { LocalStorageService } from "../../services/localStoraService";
import Button from "../../components/Button";
import Input from "../../components/Input";

declare const FB: any;
declare const window: any;
declare const loadFBSDK: any;

export default function EmbeddedSignup() {
  const launchWhatsAppSignup = () => {
    // Conversion tracking code
    // fbq && fbq('trackCustom', 'WhatsAppOnboardingStart', {
    //   appId: '702435971362183',
    //   feature: 'whatsapp_embedded_signup'
    // });

    // Launch Facebook login
    FB.login(
      (response) => {
        console.log("🚀 ~ response:", response);
        if (response.authResponse) {
          const code = response.authResponse.code;
          // The returned code must be transmitted to your backend,
          // which will perform a server-to-server call from there to our servers for an access token
        } else {
          console.log("User cancelled login or did not fully authorize.");
        }

        FB.getLoginStatus(function (response) {
          console.log(response);
        });
      },
      {
        config_id: "9619183221436393", // configuration ID goes here
        response_type: "code", // must be set to 'code' for System User access token
        override_default_response_type: true, // when true, any response types passed in the "response_type" will take precedence over the default types
        extras: {
          sessionInfoVersion: 2,
        },
      }
    );
  };

  useEffect(() => {
    document.body.className = "";


    loadFBSDK()

    window.fbAsyncInit = function () {
      // JavaScript SDK configuration and setup
      FB.init({
        appId:    '383104656966401', // Facebook App ID
        cookie:   true, // enable cookies
        xfbml:    true, // parse social plugins on this page
        version:  'v19.0' //Graph API version
      });
    };

    return () => {
      document.body.className =
        "has-navbar-vertical-aside navbar-vertical-aside-show-xl footer-offset";
    };
  }, []);

  return (
    <div className="d-flex align-items-center min-h-100">
      <main id="content" role="main" className="main bg-white pt-0">
        <div className="container-fluid px-0">
          <div className="row mx-0">
            <div className="col-lg-6 d-flex justify-content-center align-items-center min-vh-lg-100">
              <div
                className="w-100 content-space-t-4 content-space-t-lg-2 content-space-b-1"
                style={{ maxWidth: "25rem" }}
              >
                <div className="js-validate needs-validation">
                  <div className="">
                    <img
                      className="m-b-40"
                      src="/assets/img/logo.png"
                      alt="Projecter"
                    />

                    <div className="m-b-16">
                      <h1 className="display-5 m-b-8">
                        Registro integrado para WhatsApp Business
                      </h1>
                      <p>
                        Registrate en unos solos pasos para integrar el API de
                        WhatsApp Business con nuestra plataforma.
                      </p>
                    </div>

                    <div className="my-4">
                      <button onClick={launchWhatsAppSignup} className="btn-fb">
                        Login with Facebook
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-6 d-none d-lg-flex justify-content-center align-items-center min-vh-lg-100 position-relative bg-light px-0"
              style={{
                backgroundImage: "url(/assets/img/auth-bg.jpg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
          </div>
        </div>
      </main>
    </div>
  );
}
